<template>
    <div class="modal fade" id="attendanceExportModal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-md" role="document">
            <div class="modal-content border-0 shadow-lg" style="border-radius: 15px;">
                <div class="modal-header bg-teal text-white" style="border-radius: 15px 15px 0 0;">
                    <h5 class="modal-title font-weight-bold">
                        <i class="fas fa-file-excel mr-2"></i> Exportar Asistencia
                    </h5>
                    <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body p-4">
                    <p class="text-muted small mb-4">
                        Selecciona el rango de fechas para generar el reporte de asistencia detallado en formato Excel.
                    </p>
                    
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label class="font-weight-bold grey-text small">Fecha Inicial</label>
                            <input type="date" class="form-control" v-model="startDate" :max="today">
                        </div>
                        <div class="form-group col-md-6">
                            <label class="font-weight-bold grey-text small">Fecha Final</label>
                            <input type="date" class="form-control" v-model="endDate" :max="today">
                        </div>
                    </div>

                    <div class="alert alert-info mt-3 small shadow-sm border-0" style="border-radius: 10px;">
                        <i class="fas fa-filter mr-2"></i> 
                        El reporte incluirá a los **usuarios que tienes actualmente filtrados** en la tabla.
                    </div>
                </div>
                <div class="modal-footer bg-light border-0" style="border-radius: 0 0 15px 15px;">
                    <button type="button" class="btn btn-link text-muted" data-dismiss="modal">Cancelar</button>
                    <button type="button" class="btn btn-teal px-4 shadow-sm" @click="confirmExport" :disabled="!isValid">
                        <i class="fas fa-download mr-1"></i> Generar Reporte
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable no-undef */
import moment from 'moment';

export default {
    name: 'AttendanceExportModal',
    data() {
        return {
            startDate: moment().startOf('month').format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
            today: moment().format('YYYY-MM-DD')
        };
    },
    computed: {
        isValid() {
            return this.startDate && this.endDate && this.startDate <= this.endDate;
        }
    },
    methods: {
        confirmExport() {
            if (!this.isValid) return;
            
            this.$emit('confirm', {
                start_date: this.startDate,
                end_date: this.endDate
            });
            
            $('#attendanceExportModal').modal('hide');
        }
    }
};
</script>

<style scoped>
.bg-teal { background-color: #0f766e !important; }
.btn-teal {
    background-color: #0f766e;
    color: white;
    border-radius: 8px;
    font-weight: 600;
}
.btn-teal:hover {
    background-color: #0d6e66;
}
.btn-teal:disabled {
    background-color: #9ca3af;
    cursor: not-allowed;
}
.grey-text { color: #4b5563; }
</style>
